"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.getStatusResponseSecondPaymentFailedOON = exports.getStatusResponseFlexAnywhereOptedOut = exports.getStatusResponseCoveredOON = exports.getStatusResponseRentPaidOON = exports.getStatusResponseFirstPaymentPaidOON = exports.getStatusResponseScheduledExistingOONUser = exports.getStatusResponseScheduledOON = exports.getStatusResponseReadyToPay = exports.getStatusResponseSuspended = exports.getStatusResponseCannotRepayNow = exports.getStatusResponseRepayNowMultipleRepayments = exports.getStatusResponseRepayNow = exports.getStatusResponseYardiZeroBalance = exports.getStatusResponsePastDueRent = exports.getStatusResponseSelfPayOptedOut = exports.getStatusResponseSelfPayVCPendingBPWindowOpen = exports.getStatusResponseSelfPayDDAPendingBPWindowOpen = exports.getStatusResponseSelfPayPending = exports.getStatusResponseVirtualCardIssued = exports.getStatusResponseVirtualCardFirstCall = exports.getStatusResponseBalanceTooLowSLC = exports.getStatusResponseBalanceTooLow = exports.getStatusResponseZeroBalance = exports.getStatusResponseNotCovered = exports.getStatusResponseIssueMessaging = exports.getStatusResponseBalanceTooHighSLC = exports.getStatusResponseBalanceTooHigh = exports.getStatusResponseRetryDownpayment = exports.getStatusResponseDebitCard = exports.getStatusResponseRelink = exports.getStatusResponseDDAIssued = exports.getStatusResponseDDAFirstCall = exports.getStatusResponseMMFNotPaid = exports.getStatusResponseCoveredPaidInFull = exports.getStatusResponseThreeRepayments = exports.getStatusResponseMultipleRepayments = exports.getStatusResponseThirdPaymentFailed = exports.getStatusResponseSecondPaymentFailed = exports.getStatusResponseFirstPaymentPaid = exports.getStatusResponseFirstPaymentProcessing = exports.getStatusResponseRentProcessing = exports.getStatusResponseIvPending = exports.getStatusResponseRevoked = exports.getStatusResponseBlocked = exports.getStatusResponseDisputed = exports.getStatusResponseCanceled = exports.getStatusResponsePaused = exports.getStatusResponseMLA = exports.getStatusResponseNextMonth = exports.getStatusResponse = void 0;
exports.getStatusResponsePortalCredentialsInvalid = exports.getStatusResponseReschedulePayment = exports.getStatusResponsePropertyFeePassthrough = exports.getStatusResponseAdditionalPayment = exports.getStatusResponseEmbed = exports.getStatusFSLCRentPaymentProcessing = exports.getStatusFSLCDepositNotPaid = exports.getStatusResponseFlexAnywhereDDAFirstPaymentPaid = exports.getStatusResponseFlexAnywhereDDAReadyToPay = exports.getStatusResonseFlexAnywhereEarlyPay = exports.getStatusResonseFlexAnywherePendingSettlement = exports.getStatusResponseScheduledExistingFlexAnywhereDDA = exports.getStatusResponseScheduledFlexAnywhereDDA = exports.getStatusSLCCovered = exports.getStatusSLCSecondRepaymentFailed = exports.getStatusSLCFirstRepaymentFailed = exports.getStatusSLCRentPaymentProcessing = exports.getStatusSLCGetReady = exports.getStatusResponseOonSLCDisabledMonthTwoDepositPaid = exports.getStatusResponseOonTwoRepaymentsSlcSPDisabledMonthTwo = exports.getStatusResponseOonTwoRepaymentsSlcSPEnabledMonthTwo = exports.getStatusResponseOonReadyToPaySlcSPDisabledMonthTwoAdditionalDeposit = exports.getStatusResponseOonReadyToPaySlcSPDisabledMonthTwo = exports.getStatusResponseOonReadyToPaySlcSPDisabled = exports.getStatusResponseOonReadyToPaySlcSPEnabled = exports.getStatusResponseEpisodicReadyToPay = exports.getStatusResponseDefaultPaymentFailure = exports.getStatusResponseGenericPaymentFailure = exports.getStatusResponseInsufficientFunds = exports.getStatusResponsePastDownPaymentDeadline = exports.getStatusResponseFlexAnywhereMultipleRepayments = exports.getStatusResponseFundedFirstPayment = exports.getStatusResponsePreFundFirstPayment = exports.getStatusResponseCanceled2ndPaymentNotPaid = exports.getStatusResponseNotCoveredUserInitiated = exports.getStatusResponseUsedLessThanRentAmountOON = void 0;
var orchestration_1 = require("../orchestration");
var domain_1 = require("@genoa/domain");
var luxon_1 = require("luxon");
var firstRepaymentDate = luxon_1.DateTime.now().set({ day: 1 });
var secondRepaymentDate = luxon_1.DateTime.now().set({ day: 15 });
var thirdRepaymentDate = luxon_1.DateTime.now().day <= 19 ? luxon_1.DateTime.now().set({ day: 19 }) : luxon_1.DateTime.now().plus({ day: 3 });
var showNextMonthDate = luxon_1.DateTime.now().minus({ month: 1 }).endOf('month').minus({ days: 3 });
var showNextMonthDateString = showNextMonthDate.toFormat('yyyy-MM-dd');
var firstRepaymentDateString = firstRepaymentDate.toFormat('yyyy-MM-dd');
var secondRepaymentDateString = secondRepaymentDate.toFormat('yyyy-MM-dd');
var thirdRepaymentDateString = thirdRepaymentDate.toFormat('yyyy-MM-dd');
var nextMonthBPEndDate = luxon_1.DateTime.now()
    .set({ day: 6, month: luxon_1.DateTime.now().month + 1 })
    .toFormat('yyyy-MM-dd');
var nextMonthFirstRepayment = luxon_1.DateTime.now().set({ day: 1, month: luxon_1.DateTime.now().month + 1 });
var nextMonthFirstRepaymentDate = nextMonthFirstRepayment.toFormat('yyyy-MM-dd');
var nextMonthSecondRepayment = luxon_1.DateTime.now().set({ day: 15, month: luxon_1.DateTime.now().month + 1 });
var nextMonthSecondRepaymentDate = nextMonthSecondRepayment.toFormat('yyyy-MM-dd');
var nextMonthShowNextMonthDateString = luxon_1.DateTime.now().endOf('month').minus({ days: 3 }).toFormat('yyyy-MM-dd');
var bpStartDate = firstRepaymentDate.minus({ month: 1 }).endOf('month');
var lastUsedOn = bpStartDate.plus({ days: 1 }).endOf('month').toFormat('yyyy-MM-dd');
var bpEndDateString = firstRepaymentDate.set({ day: 6 }).toFormat('yyyy-MM-dd');
var billPaidDateString = firstRepaymentDate.set({ day: 3 }).toFormat('yyyy-MM-dd');
exports.getStatusResponse = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            outstanding_balance: 25512,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: firstRepaymentDate.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            property_passthrough_fee_amount: 300
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseNextMonth = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.plus({ month: 1 }).toFormat('yyyy-MM-dd'),
    bp_end_date: firstRepaymentDate.plus({ month: 1 }).toFormat('yyyy-MM-dd'),
    show_next_month_date: showNextMonthDate.plus({ month: 1 }).toFormat('yyyy-MM-dd'),
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            outstanding_balance: 25512,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseMLA = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 0,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 0,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 0
        },
    ]
};
exports.getStatusResponsePaused = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.PAUSED,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseCanceled = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.CANCELED,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseDisputed = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.DISPUTE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseBlocked = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.BLOCKED,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseRevoked = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.REVOKED,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseIvPending = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ],
    required_actions: [
        {
            type: orchestration_1.RequiredActionType.IV,
            status: orchestration_1.RequiredActionStatus.PENDING,
            updated_at: luxon_1.DateTime.now().toFormat('yyyy-MM-dd')
        },
    ]
};
exports.getStatusResponseRentProcessing = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.PROCESSING,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.AUTHORIZED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFirstPaymentProcessing = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.PROCESSING,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.AUTHORIZED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFirstPaymentPaid = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseSecondPaymentFailed = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    show_next_month_date: showNextMonthDateString,
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.FAILED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: luxon_1.DateTime.now().plus({ day: 1 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            can_pay_now: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseThirdPaymentFailed = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    show_next_month_date: showNextMonthDateString,
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 37781,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.FAILED,
            amount: 37781,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: thirdRepaymentDate.plus({ day: 1 }).toFormat('yyyy-MM-dd'),
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseMultipleRepayments = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED,
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P16D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37781,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37781,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010004',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseThreeRepayments = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED,
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P16D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 37781,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37781,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010004',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseCoveredPaidInFull = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.COVERED,
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 1,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 3.5,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 1,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseMMFNotPaid = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.COVERED,
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDate.set({ day: secondRepaymentDate.day - 1 }).toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseDDAFirstCall = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_DDA,
    service_issue_description: orchestration_1.ServiceIssueDescription.SELF_PAY_DDA.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseDDAIssued = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_DDA_ISSUED,
    service_issue_description: orchestration_1.ServiceIssueDescription.SELF_PAY_CONFIRMATION_PENDING.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseRelink = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.RELINK_PROPERTY,
    service_issue_description: orchestration_1.ServiceIssueDescription.RELINK.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseDebitCard = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.UPDATE_DEBIT_CARD,
    service_issue_description: orchestration_1.ServiceIssueDescription.UPDATE_DEBIT_CARD.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: firstRepaymentDate.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            outstanding_balance: 20000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseRetryDownpayment = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.RETRY_OR_UPDATE_CARD,
    service_issue_description: orchestration_1.ServiceIssueDescription.UPDATE_DEBIT_CARD.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            outstanding_balance: 5580
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseBalanceTooHigh = {
    actual_amount: 200000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.BALANCE_TOO_HIGH,
    service_issue_description: orchestration_1.ServiceIssueDescription.BALANCE_TOO_HIGH.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            property_passthrough_fee_amount: 300
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseBalanceTooHighSLC = {
    actual_amount: 200000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.BALANCE_TOO_HIGH,
    service_issue_description: orchestration_1.ServiceIssueDescription.BALANCE_TOO_HIGH.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            is_security_deposit: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
    ]
};
exports.getStatusResponseIssueMessaging = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.ISSUE_MESSAGING,
    service_issue_description: orchestration_1.ServiceIssueDescription.ISSUE_MESSAGING.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseNotCovered = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.NOT_COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.NOT_COVERED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.UNPAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: secondRepaymentDateString,
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
    ]
};
exports.getStatusResponseZeroBalance = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.ZERO_BALANCE,
    service_issue_description: orchestration_1.ServiceIssueDescription.BALANCE_TOO_LOW.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseBalanceTooLow = {
    actual_amount: 30000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.BALANCE_TOO_LOW,
    service_issue_description: orchestration_1.ServiceIssueDescription.BALANCE_TOO_LOW.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseBalanceTooLowSLC = {
    actual_amount: 30000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.BALANCE_TOO_LOW,
    service_issue_description: orchestration_1.ServiceIssueDescription.BALANCE_TOO_LOW.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            is_security_deposit: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
    ]
};
exports.getStatusResponseVirtualCardFirstCall = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_VC,
    service_issue_description: orchestration_1.ServiceIssueDescription.SELF_PAY_DDA.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            can_pay_now: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseVirtualCardIssued = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_VC_ISSUED,
    service_issue_description: orchestration_1.ServiceIssueDescription.SELF_PAY_CONFIRMATION_PENDING.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseSelfPayPending = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_PENDING,
    service_issue_description: orchestration_1.ServiceIssueDescription.SELF_PAY_CONFIRMATION_PENDING.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseSelfPayDDAPendingBPWindowOpen = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_DDA_PENDING_BP_WINDOW_OPEN,
    service_issue_description: orchestration_1.ServiceIssueDescription.SELF_PAY_CONFIRMATION_PENDING.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseSelfPayVCPendingBPWindowOpen = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_VC_PENDING_BP_WINDOW_OPEN,
    service_issue_description: orchestration_1.ServiceIssueDescription.SELF_PAY_CONFIRMATION_PENDING.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseSelfPayOptedOut = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.NOT_COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_OPTED_OUT,
    service_issue_description: orchestration_1.ServiceIssueDescription.NOT_COVERED_USER_INITIATED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.UNPAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponsePastDueRent = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.PAST_DUE_RENT,
    service_issue_description: orchestration_1.ServiceIssueDescription.PAST_DUE_RENT,
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseYardiZeroBalance = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.YARDI_ZERO_BALANCE,
    service_issue_description: orchestration_1.ServiceIssueDescription.YARDI_ZERO_BALANCE,
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseRepayNow = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            can_pay_now: true,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            can_reschedule: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseRepayNowMultipleRepayments = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P16D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37500,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            can_pay_now: true,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37500,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010003',
            can_pay_now: true,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010004',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseCannotRepayNow = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P16D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37500,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37500,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010003',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010004',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseSuspended = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.SUSPENDED,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.NOT_COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.NOT_COVERED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: []
};
exports.getStatusResponseReadyToPay = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.READY,
            balance: {
                limit: 175000,
                used: 0
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().minus({ day: 1 }).toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseScheduledOON = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: false,
            status: orchestration_1.CardStatus.NOT_READY,
            balance: {
                limit: 175000,
                used: 0
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().plus({ day: 1 }).toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseScheduledExistingOONUser = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.NOT_READY,
            balance: {
                limit: 175000,
                used: 0
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    bp_end_date: nextMonthBPEndDate,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: firstRepaymentDate.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            next_payment_retry_window: orchestration_1.PaymentRetryWindow.TWELVE_TO_FOURTEEN_HOURS
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFirstPaymentPaidOON = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.READY,
            balance: {
                limit: 175000,
                used: 0
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            can_pay_now: true,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseRentPaidOON = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    bill_status: orchestration_1.BillStatus.COVERED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.USED,
            balance: {
                limit: 175000,
                used: 150000
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            can_pay_now: true,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseCoveredOON = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    bill_status: orchestration_1.BillStatus.COVERED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.USED,
            balance: {
                limit: 175000,
                used: 150000
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFlexAnywhereOptedOut = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    bill_status: orchestration_1.BillStatus.NOT_COVERED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.USED,
            balance: {
                limit: 175000,
                used: 150000
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.SELF_PAY_OPTED_OUT,
    service_issue_description: orchestration_1.ServiceIssueDescription.NOT_COVERED_USER_INITIATED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.UNPAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.UNPAID,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.UNPAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseSecondPaymentFailedOON = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.USED,
            balance: {
                limit: 175000,
                used: 150000
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    show_next_month_date: showNextMonthDateString,
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.FAILED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pay_now: true,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: luxon_1.DateTime.now().plus({ day: 1 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseUsedLessThanRentAmountOON = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    out_of_network: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            created: true,
            status: orchestration_1.CardStatus.USED,
            balance: {
                limit: 175000,
                used: 90000
            },
            last_used_on: lastUsedOn
        }
    },
    flex_anywhere: undefined,
    show_next_month_date: showNextMonthDateString,
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: luxon_1.DateTime.now().plus({ day: 1 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseNotCoveredUserInitiated = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.NOT_COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.NOT_COVERED_USER_INITIATED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.UNPAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: secondRepaymentDateString,
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
    ]
};
exports.getStatusResponseCanceled2ndPaymentNotPaid = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.CANCELED,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            can_pay_now: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponsePreFundFirstPayment = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            can_pre_fund: true,
            outstanding_balance: 500
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFundedFirstPayment = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: bpStartDate.toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.FUNDED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFlexAnywhereMultipleRepayments = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED,
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P16D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 37781,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 37781,
            bill_date: thirdRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 281,
            processing_fee_percent: 0.75,
            base_amount: 37500
        },
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010004',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponsePastDownPaymentDeadline = {
    actual_amount: 100000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 100000,
    service_issue_code: orchestration_1.ServiceIssueCode.PAST_DOWNPAYMENT_DEADLINE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.FAILED,
            amount: 51750,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: 'generic_decline',
            next_auth_attempt: firstRepaymentDate.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 1750,
            processing_fee_percent: 3.5,
            base_amount: 50000,
            outstanding_balance: 51750,
            next_payment_retry_window: undefined,
            can_pre_fund: false,
            can_pay_now: undefined,
            is_security_deposit: undefined
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            failure_reason: undefined,
            next_auth_attempt: undefined,
            processing_fee: undefined,
            processing_fee_percent: undefined,
            base_amount: undefined,
            next_payment_retry_window: undefined,
            outstanding_balance: 1499,
            user_payment_public_id: '00010002',
            can_pre_fund: false,
            can_pay_now: undefined,
            is_security_deposit: undefined
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010003',
            failure_reason: undefined,
            next_auth_attempt: undefined,
            next_payment_retry_window: undefined,
            amount: 51750,
            base_amount: 50000,
            processing_fee: 1750,
            processing_fee_percent: 3.5,
            outstanding_balance: 51750,
            can_pre_fund: false,
            can_pay_now: undefined,
            is_security_deposit: undefined
        },
    ]
};
exports.getStatusResponseInsufficientFunds = {
    actual_amount: 250000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.INSUFFICIENT_FUNDS,
    service_issue_description: orchestration_1.ServiceIssueDescription.UPDATE_DEBIT_CARD.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: firstRepaymentDate.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            outstanding_balance: 20000,
            next_payment_retry_window: orchestration_1.PaymentRetryWindow.TWENTY_FOUR_TO_TWENTY_SIX_HOURS
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseGenericPaymentFailure = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.GENERIC_PAYMENT_FAILURE,
    service_issue_description: orchestration_1.ServiceIssueDescription.UPDATE_DEBIT_CARD.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: firstRepaymentDate.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            outstanding_balance: 20000,
            next_payment_retry_window: orchestration_1.PaymentRetryWindow.TWELVE_TO_FOURTEEN_HOURS
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseDefaultPaymentFailure = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.DEFAULT_PAYMENT_FAILURE,
    service_issue_description: orchestration_1.ServiceIssueDescription.UPDATE_DEBIT_CARD.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: firstRepaymentDate.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            outstanding_balance: 20000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseEpisodicReadyToPay = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().minus({ day: 1 }).toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 100000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 50562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 50000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
var getStatusOonSlcFactory = function (_a) {
    if (_a === void 0) { _a = {}; }
    var options = __rest(_a, []);
    return (__assign({ bill_transaction_id: 'A04f17c25c8368c4641c9b5abf0675d6f34', stage: domain_1.BillStage.GET_READY, bp_start_date: '2024-03-11', bp_end_date: '2024-04-05', show_next_month_date: '2024-03-28', estimation_amount: 150000, actual_amount: 0, amount_status: orchestration_1.AmountStatus.CONFIRMED, account_status: orchestration_1.AccountStatus.ACTIVE, bill_status: orchestration_1.BillStatus.SCHEDULED, membership_fee_period: orchestration_1.MembershipPeriod.P1M, membership_fee_amount: 1499, repayment_period: orchestration_1.RepaymentPeriod.P15D, service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE, service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(), payments: [
            {
                user_payment_public_id: '10001-10001-10001-10000',
                payment_status: orchestration_1.PaymentStatus.SCHEDULED,
                amount: 100000,
                base_amount: 100000,
                processing_fee: 0,
                processing_fee_percent: 0,
                outstanding_balance: 100000,
                bill_date: '2024-04-15',
                payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
                can_pre_fund: false,
                is_security_deposit: true,
                is_additional_security_deposit: false
            },
            {
                user_payment_public_id: '10001-10001-10001-10000',
                payment_status: orchestration_1.PaymentStatus.SCHEDULED,
                amount: 1499,
                outstanding_balance: 1499,
                bill_date: '2024-04-15',
                payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
                can_pre_fund: false
            },
            {
                user_payment_public_id: '10001-10001-10001-10000',
                payment_status: orchestration_1.PaymentStatus.SCHEDULED,
                amount: 51500,
                base_amount: 50000,
                processing_fee: 1500,
                processing_fee_percent: 1.0,
                outstanding_balance: 51500,
                bill_date: '2024-04-15',
                payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
                can_pre_fund: false
            },
        ], biller_type: orchestration_1.BillerType.FLEX_ANYWHERE, out_of_network: undefined, flex_anywhere: {
            payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
            virtual_card: {
                balance: {
                    limit: 175000,
                    used: 0
                },
                created: false,
                status: orchestration_1.CardStatus.NOT_READY
            }
        } }, options));
};
exports.getStatusResponseOonReadyToPaySlcSPEnabled = getStatusOonSlcFactory();
exports.getStatusResponseOonReadyToPaySlcSPDisabled = getStatusOonSlcFactory({
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-03-12',
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-04-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
exports.getStatusResponseOonReadyToPaySlcSPDisabledMonthTwo = getStatusOonSlcFactory({
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: false,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-04-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
exports.getStatusResponseOonReadyToPaySlcSPDisabledMonthTwoAdditionalDeposit = getStatusOonSlcFactory({
    bill_status: orchestration_1.BillStatus.COVERED,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1200,
            base_amount: undefined,
            processing_fee: 0,
            processing_fee_percent: undefined,
            outstanding_balance: 1200,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: true
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-04-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
exports.getStatusResponseOonTwoRepaymentsSlcSPEnabledMonthTwo = getStatusOonSlcFactory({
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-04-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ],
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            balance: {
                limit: 175000,
                used: 150000
            },
            created: false,
            status: orchestration_1.CardStatus.READY
        }
    }
});
exports.getStatusResponseOonTwoRepaymentsSlcSPDisabledMonthTwo = getStatusOonSlcFactory({
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: billPaidDateString,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: false,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-04-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ],
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.VIRTUAL_CARD,
        virtual_card: {
            balance: {
                limit: 175000,
                used: 150000
            },
            created: false,
            status: orchestration_1.CardStatus.READY
        }
    }
});
exports.getStatusResponseOonSLCDisabledMonthTwoDepositPaid = getStatusOonSlcFactory({
    bill_transaction_id: 'A05bb69439d4f35a928946b44781c0bf740',
    stage: domain_1.BillStage.RENT_PAYMENT,
    bp_start_date: '2024-02-27',
    bp_end_date: '2024-05-05',
    show_next_month_date: '2024-03-28',
    estimation_amount: 111100,
    actual_amount: 0,
    amount_status: orchestration_1.AmountStatus.ESTIMATED,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 60000,
            base_amount: 60000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 0,
            bill_date: '2024-02-27',
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-03-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '10001-10001-10001-10000',
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 51111,
            base_amount: 50000,
            processing_fee: 1111,
            processing_fee_percent: 1.0,
            outstanding_balance: 51111,
            bill_date: '2024-03-24',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 60000,
            base_amount: 60000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 60000,
            bill_date: '2024-03-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
var getStatusFlexClassicSlcFactory = function (_a) {
    if (_a === void 0) { _a = {}; }
    var options = __rest(_a, []);
    return (__assign({ bill_transaction_id: 'A04f17c25c8368c4641c9b5abf0675d6f34', stage: domain_1.BillStage.GET_READY, bp_start_date: '2024-03-11', bp_end_date: '2024-04-05', show_next_month_date: '2024-03-28', estimation_amount: 150000, actual_amount: 0, amount_status: orchestration_1.AmountStatus.CONFIRMED, account_status: orchestration_1.AccountStatus.ACTIVE, bill_status: orchestration_1.BillStatus.SCHEDULED, membership_fee_period: orchestration_1.MembershipPeriod.P1M, membership_fee_amount: 1499, repayment_period: orchestration_1.RepaymentPeriod.P15D, service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE, service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(), payments: [
            {
                user_payment_public_id: '10001-10001-10001-10000',
                payment_status: orchestration_1.PaymentStatus.SCHEDULED,
                amount: 100000,
                base_amount: 100000,
                processing_fee: 0,
                processing_fee_percent: 0,
                outstanding_balance: 100000,
                bill_date: '2024-04-15',
                payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
                can_pre_fund: false,
                is_security_deposit: true,
                is_additional_security_deposit: false
            },
            {
                user_payment_public_id: '10001-10001-10001-10000',
                payment_status: orchestration_1.PaymentStatus.SCHEDULED,
                amount: 1499,
                outstanding_balance: 1499,
                bill_date: '2024-04-15',
                payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
                can_pre_fund: false
            },
            {
                user_payment_public_id: '10001-10001-10001-10000',
                payment_status: orchestration_1.PaymentStatus.SCHEDULED,
                amount: 51500,
                base_amount: 50000,
                processing_fee: 1500,
                processing_fee_percent: 1.0,
                outstanding_balance: 51500,
                bill_date: '2024-04-15',
                payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
                can_pre_fund: false
            },
        ], biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION, out_of_network: undefined, flex_anywhere: undefined }, options));
};
exports.getStatusSLCGetReady = getStatusFlexClassicSlcFactory();
exports.getStatusSLCRentPaymentProcessing = getStatusFlexClassicSlcFactory({
    bill_status: orchestration_1.BillStatus.PROCESSING,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1200,
            base_amount: undefined,
            processing_fee: 0,
            processing_fee_percent: undefined,
            outstanding_balance: 0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-04-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
exports.getStatusSLCFirstRepaymentFailed = getStatusFlexClassicSlcFactory({
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_status: orchestration_1.BillStatus.COVERED,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1200,
            base_amount: undefined,
            processing_fee: 0,
            processing_fee_percent: undefined,
            outstanding_balance: 0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-05-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.FAILED,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-05-15',
            next_auth_attempt: '2024-05-16',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-05-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
exports.getStatusSLCSecondRepaymentFailed = getStatusFlexClassicSlcFactory({
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_status: orchestration_1.BillStatus.COVERED,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1200,
            base_amount: undefined,
            processing_fee: 0,
            processing_fee_percent: undefined,
            outstanding_balance: 0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-05-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-05-15',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.FAILED,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-05-27',
            next_auth_attempt: '2024-05-28',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
exports.getStatusSLCCovered = getStatusFlexClassicSlcFactory({
    bill_status: orchestration_1.BillStatus.COVERED,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1200,
            base_amount: undefined,
            processing_fee: 0,
            processing_fee_percent: undefined,
            outstanding_balance: 0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            outstanding_balance: 51500,
            bill_date: '2024-04-15',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 100000,
            bill_date: '2024-04-27',
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
});
exports.getStatusResponseScheduledFlexAnywhereDDA = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: undefined,
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.DDA
    },
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().plus({ day: 1 }).toFormat('yyyy-MM-dd'),
    bp_end_date: nextMonthBPEndDate,
    show_next_month_date: nextMonthShowNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseScheduledExistingFlexAnywhereDDA = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.FLEX_ANYWHERE,
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.DDA
    },
    out_of_network: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    bp_end_date: nextMonthBPEndDate,
    show_next_month_date: nextMonthShowNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: nextMonthFirstRepayment.set({ day: 5 }).toFormat('yyyy-MM-dd'),
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResonseFlexAnywherePendingSettlement = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: undefined,
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.DDA
    },
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.FA_SETTLEMENT_PENDING,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    bp_end_date: nextMonthBPEndDate,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResonseFlexAnywhereEarlyPay = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: undefined,
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.DDA
    },
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.EARLY_PAY_PAYMENT_REQUIRED,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.FIRST_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    bp_end_date: nextMonthBPEndDate,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFlexAnywhereDDAReadyToPay = {
    actual_amount: 0,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    out_of_network: undefined,
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.DDA
    },
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    bp_end_date: nextMonthBPEndDate,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseFlexAnywhereDDAFirstPaymentPaid = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.OUT_OF_NETWORK,
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.DDA
    },
    out_of_network: undefined,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            can_pay_now: true,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusFSLCDepositNotPaid = getStatusFlexClassicSlcFactory({
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 151125,
            base_amount: 150000,
            processing_fee: 1125,
            processing_fee_percent: 0.075,
            outstanding_balance: 0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
    ]
});
exports.getStatusFSLCRentPaymentProcessing = getStatusFlexClassicSlcFactory({
    bill_status: orchestration_1.BillStatus.PROCESSING,
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 151125,
            base_amount: 150000,
            processing_fee: 1125,
            processing_fee_percent: 0.075,
            outstanding_balance: 0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true,
            is_additional_security_deposit: false
        },
    ]
});
exports.getStatusResponseEmbed = {
    actual_amount: 165320,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.PROCESSING,
    bill_transaction_id: '9009000900',
    estimation_amount: 100000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.AUTHORIZED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseAdditionalPayment = {
    actual_amount: 170000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.FLEX_ANYWHERE,
    out_of_network: undefined,
    flex_anywhere: {
        payment_type: orchestration_1.FlexAnywherePaymentType.DDA
    },
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.ADDITIONAL_DEPOSIT_NEEDED,
    service_issue_description: orchestration_1.ServiceIssueDescription.ADDITIONAL_PAYMENT_REQUIRED,
    stage: domain_1.BillStage.RENT_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: domain_1.PaymentStatus.PAID,
            amount: 65000,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 65000
        },
        {
            payment_status: domain_1.PaymentStatus.ACTION_NEEDED,
            amount: 20200,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.ADDITIONAL_DEPOSIT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 200,
            processing_fee_percent: 1,
            base_amount: 20000,
            can_pay_now: true,
            is_additional_security_deposit: true
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponsePropertyFeePassthrough = {
    actual_amount: 150000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.COVERED,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    stage: domain_1.BillStage.SECOND_PAYMENT,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.PAID,
            amount: 75562,
            bill_date: firstRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75862,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            property_passthrough_fee_amount: 300
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: secondRepaymentDateString,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            can_pay_now: false,
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponseReschedulePayment = {
    actual_amount: 160000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    stage: domain_1.BillStage.GET_READY,
    biller_type: orchestration_1.BillerType.DIRECT_INTEGRATION,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_paid_date: undefined,
    bp_start_date: nextMonthFirstRepaymentDate,
    bp_end_date: nextMonthSecondRepaymentDate,
    show_next_month_date: showNextMonthDate.plus({ month: 1 }).toFormat('yyyy-MM-dd'),
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    bill_status: orchestration_1.BillStatus.SCHEDULED,
    bill_transaction_id: '9009000900',
    estimation_amount: 160000,
    service_issue_code: orchestration_1.ServiceIssueCode.NO_ISSUE,
    service_issue_description: orchestration_1.ServiceIssueDescription.SCHEDULED.toString(),
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 75000,
            can_reschedule: true,
            outstanding_balance: 500
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 75562,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            can_reschedule: true,
            base_amount: 85000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
exports.getStatusResponsePortalCredentialsInvalid = {
    actual_amount: 170000,
    account_status: orchestration_1.AccountStatus.ACTIVE,
    amount_status: orchestration_1.AmountStatus.CONFIRMED,
    biller_type: orchestration_1.BillerType.PORTAL,
    out_of_network: undefined,
    flex_anywhere: undefined,
    bill_status: orchestration_1.BillStatus.SERVICE_ISSUE,
    bill_transaction_id: '9009000900',
    estimation_amount: 150000,
    service_issue_code: orchestration_1.ServiceIssueCode.PORTAL_VALIDATE_CREDENTIALS_FAILURE,
    service_issue_description: orchestration_1.ServiceIssueDescription.PORTAL_CREDENTIALS_RELINK,
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: undefined,
    bp_start_date: firstRepaymentDateString,
    bp_end_date: bpEndDateString,
    show_next_month_date: showNextMonthDateString,
    membership_fee_period: orchestration_1.MembershipPeriod.P1M,
    membership_fee_amount: 1499,
    repayment_period: orchestration_1.RepaymentPeriod.P15D,
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 65000,
            bill_date: nextMonthFirstRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 562.5,
            processing_fee_percent: 0.75,
            base_amount: 65000
        },
        {
            payment_status: orchestration_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: nextMonthSecondRepaymentDate,
            payment_category: orchestration_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010003',
            failure_reason: '',
            next_auth_attempt: '',
            processing_fee: 0,
            processing_fee_percent: 0,
            base_amount: 1499
        },
    ]
};
